export const WORKSPACE_LOGIN_PAUSED_ERROR = 'workspace_login_paused'
export const WORKSPACE_LOGIN_PAUSED_CODE = 'WORKSPACE_LOGIN_PAUSED'
export const WORKSPACE_LOGIN_PAUSED_MESSAGE =
  'This workspace is paused, so login is disabled for now. Contact Trellis support if you need access.'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function isWorkspaceLoginPaused(settings: unknown): boolean {
  return isRecord(settings) && settings.loginPaused === true
}
